<template>
  <div class="d-flex">
   
      <!--<label for="inputYear" class="form-label">Year</label>-->
      <select class="form-select form-select" aria-label="Year" v-model="year" :disabled="!enabled"  @change="handleChange">
        <option v-for="(u,i) in availableYears" :value="u" >{{u}}</option>
      </select>
    


  
      <!--<label for="inputMonth" class="form-label">Month</label>-->
      <select class="form-select form-select" aria-label="Month" v-model="month" :disabled="!enabled"  @change="handleChange">
        <option v-for="(u,i) in availableMonths" :value="u">{{getMonthLabel(u)}}</option>
      </select>


   
      <!--<label for="inputDate" class="form-label">Date</label>-->
      <select class="form-select form-select" aria-label="Date" v-model="date" :disabled="!enabled"  @change="handleChange">
        <option v-for="(u,i) in availableDates" :value="u">{{u}}</option>
      </select>
 
  </div>

</template>

<script>
export default {
  name: 'vcdatepicker',
  props: {
    modelValue:Object,
    enabled:Boolean,
    minValue:Object,
    maxValue:Object,
  },
  emits: ['update:modelValue'],
  data() {
    return {
      year:1970,
      month:1,
      date:1,
    }
  },
  methods:{
    getMonthLabel(month) {
      const date = new Date(2009, month-1, 10);  // 2009-11-10
      const monthText = date.toLocaleString('default', { month: 'short' });
      return monthText;
    },
    setFromDate(date) {
      let me=this;
      if (!date) {
        me.year=1970;
        me.month=1;
        me.date=1;
      } else {
        me.year=date.getFullYear();
        me.month=date.getMonth()+1;
        me.date=date.getDate();
      }

     //console.log( `setFromDate ${me.year}-${me.month}-${me.date}`)
    },
    handleChange() {
      let me=this;
      let newValue= new Date(me.year,me.month-1, me.date, 0,0,0,0);
      me.$emit("update:modelValue",   newValue);
    },
  },
  computed:{
    /*
    resolvedDate() {
      let me=this;
      console.log( `resolvedDate ${me.year}-${me.month}-${me.date}`)
      return new Date(me.year,me.month-1, me.date, 0,0,0,0);
    },*/
    availableYears() {
      let me=this;
      const years=[];
      const minYear=me.minValue?me.minValue.getFullYear():1970;
      const maxYear=me.maxValue?me.maxValue.getFullYear():new Date().getFullYear()+5;
      for (let i=minYear;i<maxYear+1;i++) {
        years.push(i);
      }
      return years;
    },
    availableMonths() {
      let me=this;
      const months=[];
      let minMonth=1;
      let maxMonth=12;
      if (me.minValue && me.year===me.minValue.getFullYear()) {
        minMonth=me.minValue.getMonth()+1;
      } else if (me.maxValue && me.year===me.maxValue.getFullYear()) {
        maxMonth=me.maxValue.getMonth()+1;
      }
      for (let i=minMonth;i<maxMonth+1;i++) {
        months.push(i);
      }
      return months;
    },
    availableDates() {
      let me=this;
      const dates=[];
      let minDate=1;
      let maxDate=new Date(me.year, me.month, 0).getDate();
      if (me.minValue && me.year===me.minValue.getFullYear() && me.month===me.minValue.getMonth()+1) {
        minDate=me.minValue.getDate();
      } else if (me.maxValue && me.year===me.maxValue.getFullYear() && me.month===me.maxValue.getMonth()+1) {
        maxDate=me.maxValue.getDate();
      }
      for (let i=minDate; i<maxDate+1;i++) {
        dates.push(i);
      }
      return dates;
    },
    /*
    year: {
      get: function () {
        let me=this;
        return me.localDate?me.localDate.getFullYear():1970;
      },
      set: function (newValue) {
        var me=this;
        me.localDate.setFullYear(newValue);
        me.$emit("update:modelValue",   me.localDate);
      }
    },
    month: {
      get: function () {
        let me=this;
        return me.localDate?me.localDate.getMonth()+1:1;
      },
      set: function (newValue) {
        var me=this;
        
        me.localDate.setMonth(newValue-1);
        me.$emit("update:modelValue",   me.localDate);
      }
    },
    date: {
      get: function () {
        let me=this;
        return me.localDate?me.localDate.getDate():1;
      },
      set: function (newValue) {
        var me=this;
        me.localDate.setDate(newValue);
        me.$emit("update:modelValue",   me.localDate);
      }
    },
    */
    
  },
  watch: {

    modelValue:{
      handler:function(newValue,oldValue) {
        let me=this;
        me.setFromDate(newValue);
       // me.localDate=newValue?new Date(newValue.getTime()):new Date();
      },
    },
    
    /*
    resolvedDate: {
      handler:function(newValue,oldValue) {
        let me=this;

      
        if (me.modelValue && newValue.getTime()!==me.modelValue.getTime()) {
          console.log(`Change: ${newValue.getFullYear()}-${newValue.getMonth()+1}-${newValue.getDate()} from ${me.modelValue.getFullYear()}-${me.modelValue.getMonth()+1}-${me.modelValue.getDate()}`)
          me.$emit("update:modelValue",   newValue);
        } else {
          console.log(`Same: ${newValue.getFullYear()}-${newValue.getMonth()+1}-${newValue.getDate()}`)
        }
       
      }
    }*/
  },
  mounted() {
    let me=this;
    me.setFromDate(me.modelValue);
    //me.localDate=me.modelValue?new Date(me.modelValue.getTime()):new Date();
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>